import { render, staticRenderFns } from "./HeaderFrontend.vue?vue&type=template&id=e7e5bd44&scoped=true&"
import script from "./HeaderFrontend.vue?vue&type=script&lang=js&"
export * from "./HeaderFrontend.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/frontend/header.scss?vue&type=style&index=0&id=e7e5bd44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7e5bd44",
  null
  
)

export default component.exports